var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue3-slot"},[_c('h2',[(_vm.$slots.header)?_vm._t("header",function(){return [_vm._v("Заголовок слота")]}):_vm._e()],2),(_vm.$slots.problem)?_vm._t("problem",function(){return [_vm._v("Проблематика слота")]}):_vm._e(),(_vm.$slots.default)?_vm._t("default",function(){return [_vm._v("Перешние проблемы")]}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }